import _get from 'lodash/get';
import Questionnaire from '@/containers/Questionnaire/Questionnaire';

export default class QuestionnaireFlow {
  constructor({ questionnaires, back, next, additionalMapperFields }) {
    this.questionnaires = questionnaires || [];
    this.back = back || false;
    this.next = next || false;
    this.additionalMapperFields = additionalMapperFields || (() => {});
  }

  setNext(next) {
    this.next = next;
  }

  setBack(back) {
    this.back = back;
  }

  getFirst() {
    return _get(this.questionnaires.slice().shift(), 'path', this.next);
  }

  getLast() {
    return _get(this.questionnaires.slice(-1).pop(), 'path', this.back);
  }

  getSteps() {
    return this.questionnaires.map((questionnaire, index, steps) => ({
      id: questionnaire.path,
      path: questionnaire.path,
      Container: Questionnaire,
      back: _get(steps[index - 1], 'path', this.back),
      next: _get(steps[index + 1], 'path', this.next),
      extraProps: { questionnaireIdentifier: `${questionnaire.id}` },
      skip: questionnaire.skip,
      ...this.additionalMapperFields(questionnaire),
    }));
  }
}
